export abstract class AbstractStore {}
